/*
 * @Description: 获取用户usessionId,存储 含过期时间，过期重新获取
 * @Author: luozhao
 * @Date: 2021-04-07 09:34:42
 */
import api from './crosRequestHandler.js';
import BetterStorage from './betterStorage.service.js';
const betterStorage = new BetterStorage();

/**
 * @description: 保持用户 usessionid 心跳 设置usessionid心跳时长 30 分钟
 * @author luozhao
 * @export
 * @returns
 */
export async function getUsessionId () {
  const usessionid = sessionStorage.getItem('usessionid');
  let usessionidKeep = betterStorage.get('usessionidKeep');
  const platformVersion = sessionStorage.getItem('platformVersion');
  if (!usessionidKeep) {
    if (platformVersion === '6') {
      const { result } = await api({
        method: 'post',
        data: {
          intername: 'aamif.url',
          requestUri: `/aamif/rest/account/heartbeat/${usessionid}`,
          requestType: 'get'
        }
      });
      if (result === '000000') {
        betterStorage.set('usessionidKeep', usessionid, 30 * 60 * 1000);
      }
    } else {
      const { code } = await api({
        method: 'post',
        data: {
          intername: 'aamif.url',
          requestUri: `/account/api/account/heartbeat?usession_id=${usessionid}`,
          requestType: 'get'
        }
      });
      if (code === '000000') {
        betterStorage.set('usessionidKeep', usessionid, 30 * 60 * 1000);
      }
    }
  }
  return usessionid;
}